import React from 'react';
import { bodiedSyncBlock, syncBlock } from '@atlaskit/adf-schema';
import { blockTypeMessages } from '@atlaskit/editor-common/messages';
import { IconSyncBlock } from '@atlaskit/editor-common/quick-insert';
import { SyncBlockStoreManager } from '@atlaskit/editor-synced-block-provider';
import Lozenge from '@atlaskit/lozenge';
import { flushBodiedSyncBlocks as _flushBodiedSyncBlocks } from './editor-actions';
import { copySyncedBlockReferenceToClipboardEditorCommand, createSyncedBlock } from './editor-commands';
import { createPlugin, syncedBlockPluginKey } from './pm-plugins/main';
import { getBlockMenuComponents } from './ui/block-menu-components';
import { DeleteConfirmationModal } from './ui/DeleteConfirmationModal';
import { Flag } from './ui/Flag';
import { getToolbarConfig } from './ui/floating-toolbar';
import { SyncBlockRefresher } from './ui/SyncBlockRefresher';
import { getToolbarComponents } from './ui/toolbar-components';
export var syncedBlockPlugin = function syncedBlockPlugin(_ref) {
  var _api$blockMenu, _api$toolbar;
  var config = _ref.config,
    api = _ref.api;
  var syncBlockStore = new SyncBlockStoreManager(config === null || config === void 0 ? void 0 : config.syncBlockDataProvider);
  api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 || _api$blockMenu.actions.registerBlockMenuComponents(getBlockMenuComponents(api));
  api === null || api === void 0 || (_api$toolbar = api.toolbar) === null || _api$toolbar === void 0 || _api$toolbar.actions.registerComponents(getToolbarComponents(api));
  return {
    name: 'syncedBlock',
    nodes: function nodes() {
      return [{
        name: 'syncBlock',
        node: syncBlock
      }, {
        name: 'bodiedSyncBlock',
        node: bodiedSyncBlock
      }];
    },
    pmPlugins: function pmPlugins() {
      return [{
        name: 'syncedBlockPlugin',
        plugin: function plugin(params) {
          return createPlugin(config, params, syncBlockStore, api);
        }
      }];
    },
    commands: {
      copySyncedBlockReferenceToClipboard: function copySyncedBlockReferenceToClipboard() {
        return copySyncedBlockReferenceToClipboardEditorCommand;
      },
      insertSyncedBlock: function insertSyncedBlock() {
        return function (_ref2) {
          var tr = _ref2.tr;
          return createSyncedBlock({
            tr: tr,
            syncBlockStore: syncBlockStore
          }) || null;
        };
      }
    },
    actions: {
      flushBodiedSyncBlocks: function flushBodiedSyncBlocks() {
        return _flushBodiedSyncBlocks(syncBlockStore);
      }
    },
    pluginsOptions: {
      quickInsert: function quickInsert(_ref3) {
        var formatMessage = _ref3.formatMessage;
        return [{
          id: 'syncBlock',
          title: formatMessage(blockTypeMessages.syncedBlock),
          description: formatMessage(blockTypeMessages.syncedBlockDescription),
          priority: 800,
          keywords: ['synced', 'block', 'synced-block', 'sync', 'sync-block', 'auto', 'update', 'excerpt', 'connect'],
          isDisabledOffline: true,
          keyshortcut: '',
          lozenge: /*#__PURE__*/React.createElement(Lozenge, {
            appearance: "new"
          }, formatMessage(blockTypeMessages.newLozenge)),
          icon: function icon() {
            return /*#__PURE__*/React.createElement(IconSyncBlock, {
              label: formatMessage(blockTypeMessages.syncedBlock)
            });
          },
          action: function action(insert, state) {
            return createSyncedBlock({
              tr: state.tr,
              syncBlockStore: syncBlockStore,
              typeAheadInsert: insert
            });
          }
        }];
      },
      floatingToolbar: function floatingToolbar(state, intl) {
        return getToolbarConfig(state, intl, api, syncBlockStore);
      }
    },
    contentComponent: function contentComponent() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SyncBlockRefresher, {
        syncBlockStoreManager: syncBlockStore,
        api: api
      }), /*#__PURE__*/React.createElement(DeleteConfirmationModal, {
        syncBlockStoreManager: syncBlockStore,
        api: api
      }), /*#__PURE__*/React.createElement(Flag, {
        api: api
      }));
    },
    getSharedState: function getSharedState(editorState) {
      if (!editorState) {
        return;
      }
      var _syncedBlockPluginKey = syncedBlockPluginKey.getState(editorState),
        showFlag = _syncedBlockPluginKey.showFlag,
        currentSyncBlockStore = _syncedBlockPluginKey.syncBlockStore;
      return {
        showFlag: showFlag,
        syncBlockStore: currentSyncBlockStore
      };
    }
  };
};